import { Box } from '@mui/material'
import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { connect } from 'react-redux'
import {
  ArcElement,
  ChartData,
  Chart as ChartJS,
  Legend,
  Tooltip
} from 'chart.js'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { IncidentReport } from 'types/incident-report'
import { mapOperationsToDispatchProps } from 'utils/common'

ChartJS.register(ArcElement, Tooltip, Legend)

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwnProps {
  reportData: IncidentReport[]
}

type AppProps = StateProps & DispatchProps & OwnProps

const IncidentReportChartFC: React.FC<any> = (props: AppProps) => {
  const { theme, reportData } = props
  const [dataPoints, setDataPoints] = React.useState({
    resolved: 0,
    pending: 0,
    inProgress: 0
  })

  const chartData: ChartData<any> = {
    labels: ['Resolved', 'Pending', 'In-Progress'],
    datasets: [
      {
        label: 'Total Incidents',
        data: [dataPoints.resolved, dataPoints.pending, dataPoints.inProgress],
        backgroundColor: [
          theme.primaryColor,
          theme.tertiaryColor,
          theme.quaternaryColor
        ],
        borderColor: theme.secondaryColor,
        borderWidth: 1
      }
    ]
  }

  React.useEffect(() => {
    let resolved = 0
    let pending = 0
    let inProgress = 0

    reportData.forEach(data => {
      switch (data.status) {
        case 'In-Progress': {
          inProgress++
          break
        }
        case 'Resolved': {
          resolved++
          break
        }
        default: {
          pending++
        }
      }
    })

    setDataPoints({
      resolved,
      pending,
      inProgress
    })
  }, [reportData])

  return (
    <Box>
      <Doughnut data={chartData} />
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const IncidentReportChart = connect(
  mapStateToProps,
  mapDispatchToProps
)(IncidentReportChartFC) as React.FC<OwnProps>

export default IncidentReportChart
